import { useAxiosStore } from "js/stores/axiosStore";

export default {
    data() {
        return {
            errors: {},
        };
    },
    methods: {
        reportError(obj) {
            if (!this.errors[obj.key]) {
                this.errors[obj.key] = [];
            }
            this.errors[obj.key].push(obj.error);
        },
        handleResponseErrors(err) {
            if (err.response?.status === 422) {
                this.errors = err.response.data.errors;
                Object.keys(this.errors).forEach((key) => {
                    const match = key.match(/^(.+)\.\d+\.[^.]+$/);
                    if (!match) {
                        return;
                    }
                    const parentKey = match[1];
                    this.errors[parentKey] = (
                        this.errors[parentKey] ?? []
                    ).concat(this.errors[key]);
                });
            } else {
                const axiosStore = useAxiosStore();
                axiosStore.setUploadError(
                    err.response?.data?.message ||
                        err.message ||
                        "An unexpected error occurred during upload."
                );
                console.error(err);
            }
        },
        clearError(field) {
            if (this.errors[field] === undefined) {
                return;
            }
            delete this.errors[field];
        },
        clearErrors() {
            this.errors = {};
        },
    },
};
